import { render, staticRenderFns } from "./web-form.vue?vue&type=template&id=4a15e9e2&scoped=true&"
import script from "./web-form.vue?vue&type=script&lang=js&"
export * from "./web-form.vue?vue&type=script&lang=js&"
import style0 from "./web-form.vue?vue&type=style&index=0&id=4a15e9e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a15e9e2",
  null
  
)

export default component.exports